<mat-card class="lag-device flex flex-row gap-[10px] justify-start items-center">
  <img [src]="lagDevice.imageUri || getStandardImageUri()" class="device-img" />
  <div>
    <div class="label-name">{{ lagDevice.name }}</div>
    <div class="label-serial">{{ lagDevice.id }}</div>
    <div class="footer-container flex flex-row gap-[80px] justify-start items-center">
      <app-pill type="{{ lagDevice.burnerStatus ? pillType.success : pillType.brand }}">{{
        lagDevice.burnerStatus | translateCascadesBurnerStatus
      }}</app-pill>
      <button
        mat-stroked-button
        class="btn-show-more"
        gtm="onOpen"
        gtmAction="Lag device details"
        gtmCategory="cascadesLagDevice"
        (click)="openLagDeviceDialog(lagDevice.id)"
      >
        <span>{{ 'GENERAL.BUTTON.SHOW_MORE' | translate }}</span>
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>
</mat-card>
